import React, { Fragment, useEffect, useState } from "react";
import {
  CircularProgress,
  Grid,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";
import { Chart } from "react-charts";

import { axes, defs } from "./chartOptions";
import jMoment from "moment-jalaali";
import { shallowEqual, useSelector } from "react-redux";
import { selectUser } from "../../../features/data/user/userSlice";
jMoment.loadPersian({ dialect: "persian-modern", usePersianDigits: true });

const useStyles = makeStyles(() => ({
  paper: {
    marginRight: 10,
    marginBottom: 10,
    height: 180,
    padding: 10,
  },
}));

const Charts = (props) => {
  const classes = useStyles();
  const { loading, charts = [] } = props;
  const [chartsData, setChartsData] = useState({
    myValuationsChartData: [
      {
        label: "",
        data: [],
      },
    ],
    allValuationsChartData: [
      {
        label: "",
        data: [],
      },
    ],
  });
  const { user } = useSelector(selectUser, shallowEqual);

  useEffect(() => {
    if (charts.myValuationsChartData && charts.allValuationsChartData) {
      const myValuationsArray = [];
      for (const [key, value] of Object.entries(charts.myValuationsChartData)) {
        myValuationsArray.push([
          jMoment(key).format("jMMMM/jD").toString(),
          value,
        ]);
      }
      const allValuationsArray = [];
      for (const [key, value] of Object.entries(
        charts.allValuationsChartData,
      )) {
        allValuationsArray.push([
          jMoment(key).format("jMMMM/jD").toString(),
          value,
        ]);
      }
      setChartsData({
        myValuationsChartData: [
          { label: "ارزیابی‌ها", data: myValuationsArray },
        ],
        allValuationsChartData: [
          { label: "ارزیابی‌ها", data: allValuationsArray },
        ],
      });
    }
  }, [charts]);

  return (
    <Fragment>
      <Grid
        item
        xs={12}
        md={
          user?.role === "user" || user?.role === "global_limited_user" ? 12 : 6
        }
      >
        <Paper className={classes.paper}>
          <Typography
            style={{
              fontWeight: "bold",
              fontSize: "15px",
              marginBottom: 10,
            }}
          >
            نمودار روزانه ارزیابی های من
          </Typography>
          <Grid
            style={{
              width: "100%",
              height: 120,
            }}
            alignContent="center"
            justifyContent="center"
            alignItems="center"
            container
            item
            xs={12}
          >
            {loading ? (
              <CircularProgress style={{ color: "#757575" }} />
            ) : (
              <Chart
                data={chartsData.myValuationsChartData}
                axes={axes}
                getSeriesStyle={() => ({
                  color: `url(#${3})`,
                })}
                renderSVG={() => defs}
                tooltip
                series={{ type: "area" }}
              />
            )}
          </Grid>
        </Paper>
      </Grid>

      {user.role === "admin" && (
        <Grid item xs={12} md={6}>
          <Paper
            style={{
              marginBottom: 10,
              height: 180,
              padding: 10,
            }}
          >
            <Typography
              style={{
                fontWeight: "bold",
                fontSize: "15px",
                marginBottom: 10,
              }}
            >
              نمودار روزانه ارزیابی های سایت
            </Typography>
            <Grid
              style={{
                width: "100%",
                height: 120,
              }}
              container
              item
              xs={12}
              alignContent="center"
              justifyContent="center"
              alignItems="center"
            >
              {loading ? (
                <CircularProgress style={{ color: "#757575" }} />
              ) : (
                <Chart
                  data={chartsData.allValuationsChartData}
                  axes={axes}
                  getSeriesStyle={() => ({
                    color: `url(#${0})`,
                  })}
                  renderSVG={() => defs}
                  tooltip
                  series={{ type: "area" }}
                />
              )}
            </Grid>
          </Paper>
        </Grid>
      )}
    </Fragment>
  );
};

export default Charts;
